<div class="md-ue-campaign-element">
    <div class="md-ue-campaign-message" id="md-ue-campaign-message">
        <blockquote>
            <p class="p-2">EUROPA PENTRU TINE! Află despre beneficiile și oportunitățile oferite Republicii Moldova de Uniunea Europeană</p>
            <span id="md-ue-campaign-message-close-btn" (click)="onCloseButtonClick()"><strong>x</strong></span>
        </blockquote>
    </div>
    <div class="md-ue-campaign-circle" id="md-ue-campaign-circle" (click)="onCircleClick()">
        <div class="sonar-wave"></div>
        <div class="md-ue-campaign-logo"></div>
    </div>
</div>
